<div id="overlay-table">
    <div class="overlay-message"></div>
</div>

<div id="table-orders" (scroll)="checkScroll($event)" [ngClass]="{'min-height': serverError && isRateLookup}"
    class="main-table-container mat-elevation-z1" style="position: relative;padding:0px" [ngStyle]="$safeNavigationMigration(tabelConfig?.style)">
    <div *ngIf="serverError && !isRateLookup" tabindex="-1" id="error" class="error-message">{{serverError}}</div>
    <div *ngIf="serverError && isRateLookup">
        <div tabindex="-1" id="error" class="error-message-image"><img
                src="../../../../../../assets/images/rate-lookup-icons/rate-lookup-icons.svg#svgView(viewBox(0,400,75,64))" class="error-image"></div>
        <div tabindex="-1" class="error-message-ratelookup">No valid rates were found for the given criteria. Please
            verify
            your search criteria or <a class="link-style" href="">contact DHL </a>if rates are missing</div>

    </div>
    <div>
        <table [hidden]="!(serverError && isRateLookup) && resultView !== 'list'" mat-table [dataSource]="dataSource" matSort>
        <ng-container style="position: relative;" *ngFor="let data of tabelConfig.TableHeaders; let i= index;"
            [matColumnDef]="data.title">
            <ng-container matColumnDef="rowSelect" *ngIf="i === 0 && tabelConfig.rowOptions">
                <span *ngIf="tabelConfig.rowOptions.mutipleRowOperation">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox [disabled]="data.disabled" (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox [disabled]="data.disabled" (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                            [aria-label]="checkboxLabel(row)">
                        </mat-checkbox>
                    </td>
                </span>
            </ng-container>

                <th mat-header-cell mat-sort-header *matHeaderCellDef [ngStyle]="{'max-width.px': data.width}">
                    {{data.title.toUpperCase()}}
                </th>
                <td mat-cell *matCellDef="let element" [ngStyle]="{'max-width.px': data.width}">

                <span *ngIf="i === tabelConfig.TableHeaders.length-1">
                    <span *ngIf="tabelConfig.rowOptions && tabelConfig.rowOptions.rowMenuOption && checkEditOwnAccess(element)" style="position: absolute;right: 0;">
                        <button mat-button mat-icon-button matTooltip="Menu" [matMenuTriggerFor]="menu"
                            aria-label="Example icon-button with a menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" overlapTrigger>
                            <ng-container *ngIf="tabelConfig.rowOptions">
                                <ng-container *ngIf="tabelConfig.rowOptions.rowMenuOption">
                                    <button mat-menu-item color="accent"
                                        *ngFor="let action of tabelConfig.rowOptions.rowMenuOption" [disabled]="$safeNavigationMigration(action?.action?.disabled)"
                                        (click)="performAction($event, action.name, element, action, null)">

                                        <mat-icon *ngIf="action.icon" class="fa" style="cursor:pointer"
                                            matTooltip="{{action.toolTip}}">
                                            {{action.icon}}
                                        </mat-icon>
                                        <span> {{action.label}}</span>
                                    </button>
                                </ng-container>
                            </ng-container>
                        </mat-menu>
                    </span>
                    <span *ngIf="tabelConfig.actions" class="action-icons">
                        <span *ngFor="let action of tabelConfig.actions">
                            <button type="button" mat-button mat-icon-button color="accent"
                                (click)="performAction($event, action.name, element, action, null)">
                                <mat-icon class="fa" style="cursor:pointer" matTooltip="{{action.toolTip}}">
                                    {{action.icon}}
                                </mat-icon>
                            </button>
                        </span>
                    </span>
                </span>

                <span>
                    <span *ngIf="data.primaryText"  title="{{ element[data.primaryText.key] && element[data.primaryText.key].indexOf('<br>') > -1 ? updatedTitleFn(element[data.primaryText.key]) : element[data.primaryText.key]}}">
                        <span *ngIf="data.primaryText.key === 'transportMode'">
                            <img *ngIf="element[data.primaryText.key] === 'TL'" class="transport-image"
                                src="../../../../../../assets/images/rate-lookup-icons/rate-lookup-icons.svg#svgView(viewBox(0,0,48,48))">
                            <img *ngIf="element[data.primaryText.key] === 'LTL'" class="transport-image"
                                src="../../../../../../assets/images/rate-lookup-icons/rate-lookup-icons.svg#svgView(viewBox(0,50,48,48))">
                            <img *ngIf="element[data.primaryText.key] === 'INTERMODAL'" class="transport-image"
                                src="../../../../../../assets/images/rate-lookup-icons/rate-lookup-icons.svg#svgView(viewBox(0,100,48,48))">
                        </span>
                        <img *ngIf="element[data.primaryText.key] === 'N'" class="circle-image"
                            src="../../../../../../assets/images/rate-lookup-icons/rate-lookup-icons.svg#svgView(viewBox(0,465,32,32))">
                        <img *ngIf="element[data.primaryText.key] === 'Y'" class="circle-image"
                            src="../../../../../../assets/images/rate-lookup-icons/rate-lookup-icons.svg#svgView(viewBox(50,465,32,32))">
                        <span
                            *ngIf="!(element[data.primaryText.key] === 'N' || element[data.primaryText.key] === 'Y') && element[data.primaryText.key]" [innerHTML]="element[data.primaryText.key] | safeHtml"></span>
                    </span>
                    <br>
                    <span [ngClass]="{'whiteSpace' :data.whiteSpace}" *ngIf="data.secondaryText" class="cell-secondary-value">
                        {{element[data.secondaryText.key]}}
                    </span>
                </span>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="newDisplayedColumns; sticky: true"></tr>
        <tr mat-row (click)="onRowClickHandler(row)" class="data-row"
            *matRowDef="let row; columns: newDisplayedColumns;"> </tr>
    </table>
      
      <!-- CP-6330 -->
        <div *ngIf = "showLoadMoreLabel && dataSource.data.length && (dataSource.data.length % tabelConfig.maxRows === 0)" class= "dhl-table-pagination-label" (click)="getInitialOrdersList()"> Load More</div>
      
        <!-- <ng-template > -->
        <div [hidden]="!(serverError && isRateLookup) && resultView !== 'card'" class="card-data">
            <div class="card" (click)="selectCard(i)" [ngClass]="{'selected-card':indexNum === i}"
                *ngFor="let element of tableData; let i= index;">
                <div class="row" [ngClass]="{'highlight-selection':data.primaryText.key === 'totalCost'}"
                    *ngFor="let data of tabelConfig.TableHeaders; let i= index;">
                    <div class="col-md-5 title-style" [ngClass]="{'active-title-style':data.primaryText.key === 'totalCost'}">{{data.title.toUpperCase()}}</div>
                    <div class="col-md-6 element-style" [ngClass]="{'active-element-style':data.primaryText.key === 'totalCost'}">
                        <span *ngIf="data.primaryText" title="{{element[data.primaryText.key]}}">
                            <span *ngIf="data.primaryText.key === 'transportMode'">
                                <img *ngIf="element[data.primaryText.key] === 'TL'" class="transport-image"
                                    src="../../../../../../assets/images/rate-lookup-icons/rate-lookup-icons.svg#svgView(viewBox(0,0,48,48))">
                                <img *ngIf="element[data.primaryText.key] === 'LTL'" class="transport-image"
                                    src="../../../../../../assets/images/rate-lookup-icons/rate-lookup-icons.svg#svgView(viewBox(0,50,48,48))">
                                <img *ngIf="element[data.primaryText.key] === 'INTERMODAL'" class="transport-image"
                                    src="../../../../../../assets/images/rate-lookup-icons/rate-lookup-icons.svg#svgView(viewBox(0,100,48,48))">
                            </span>
                            <img *ngIf="element[data.primaryText.key] === 'N'" class="circle-image"
                                src="../../../../../../assets/images/rate-lookup-icons/rate-lookup-icons.svg#svgView(viewBox(0,465,32,32))">
                            <img *ngIf="element[data.primaryText.key] === 'Y'" class="circle-image"
                                src="../../../../../../assets/images/rate-lookup-icons/rate-lookup-icons.svg#svgView(viewBox(50,465,32,32))">
                            <span
                                *ngIf="!(element[data.primaryText.key] === 'N' || element[data.primaryText.key] === 'Y')">{{element[data.primaryText.key]}}</span>

                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-progress-spinner-v2 *ngIf="isLoading"></app-progress-spinner-v2>
